import { render, staticRenderFns } from "./WineCellar.vue?vue&type=template&id=6a9e6aaa"
import script from "./WineCellar.vue?vue&type=script&lang=js"
export * from "./WineCellar.vue?vue&type=script&lang=js"
import style0 from "./WineCellar.vue?vue&type=style&index=0&id=6a9e6aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports